<template>
  <div id="viewAfter">
    <div class="box">
      <el-steps :active="setp" align-center finish-status="success">
        <el-step
          title="提交售后申请"
          :description="dayjs.unix(data.create_date).format('YYYY-MM-DD hh:mm:ss')"
        ></el-step>
        <el-step title="审核中"></el-step>
        <el-step :title="endText"></el-step>
      </el-steps>
       <div style="border:1px solid rgba(221, 221, 221, 1);line-height:50px;margin-top:30px" v-if="data.status==4||data.status==3">
        <span class="lv3Text" style="margin: 20px 0">审核留言 ： </span>
        <span clas="lv3Text">{{data.remark}}</span>
      </div>
      <div class="lv3Text" style="margin:20px 0">服务单信息</div>
      <div class="lv2Text">
        <table>
          <tr>
            <td class="b1">服务单号</td>
            <td class="t1 lv1Text">{{data.code}}</td>
          </tr>
          <tr>
            <td class="b1">申请时间</td>
            <td class="t1 lv1Text">{{dayjs.unix(data.create_date).format('YYYY-MM-DD hh:mm:ss')}}</td>
          </tr>
          <tr>
            <td class="b1">服务类型</td>
            <td class="t1 lv1Text">{{data.code}}</td>
          </tr>
          <tr>
            <td class="b1">退货原因</td>
            <td class="t1 lv1Text">{{data.cause}}</td>
          </tr>
          <tr>
            <td class="b1">数量</td>
            <td class="t1 lv1Text">{{data.number}}</td>
          </tr>
          <tr>
            <td class="b1">联系人</td>
            <td class="t1 lv1Text">{{data.link_name}}</td>
          </tr>
          <tr>
            <td class="b1">联系电话</td>
            <td class="t1 lv1Text">{{data.link_mobile}}</td>
          </tr>
          <tr>
            <td class="b1">商品金额</td>
            <td class="t1 lv1Text">&yen;{{data.return_money}}</td>
          </tr>
          <tr>
            <td class="b1">运费</td>
            <td class="t1 lv1Text">&yen;{{data.express_money}}</td>
          </tr>
          <tr>
            <td class="b1">退款金额</td>
            <td class="t1 lv1Text">&yen;{{data.sure_return_money}}</td>
          </tr>
        </table>
      </div>
      <!-- <div v-if="data.status==4">
        <div class="lv3Text" style="margin: 20px 0">退货地址</div>
        <div class="lv2Text box2">
          <div style="margin-bottom:10px">收货人：{{address.name+' '+address.link_mobile}}</div>
          <div>收货地址：{{address.province+" "+address.city+" "+address.area+" "+address.address}}</div>
        </div>
      </div> -->
     
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      data: {},
      id: this.$route.query.id,
      setp: 1,
      address: "",
      endText: "处理完成"
    };
  },
  watch: {},
  created() {
    //
    this.$store.state.user_location = "售后服务";
    this.$store.state.leftMenuIndex = 15;
    this.initData();
  },
  methods: {
    //
    initData() {
      var json = {
        mobile: this.mobile,
        token: this.token,
        return_id: this.id
      };
      this.axios
        .get(this.serve + "/personal/return_product_detail", {
          params: json
        })
        .then(res => {
          console.log(res)
          this.data = res.data.data.return_detail;
          if (this.data.status == 3 || this.data.status == 4) {
            this.setp = 3;
          } else {
            this.setp = parseInt(this.data.status );
          }
          if (this.data.status == 3) {
            this.endText = "审核未通过";
          }
          if (this.data.status == 4) {
            this.endText = "审核通过";
          }
          this.address = res.data.data.address;
        });
    }
  }
};
</script>
<style lang="scss">
#viewAfter {
 
  .box2 {
    border: 1px solid #ddd;
    padding: 10px 20px;
  }
  .t1 {
    padding-left: 20px;
  }
  .b1 {
    background-color: #f2f6fc;
    width: 180px;
    text-align: center;
  }
  .box {
    background-color: #fff;
    padding: 20px 0 200px 20px;
    .el-step__title.is-success,
    .el-step__head.is-success,
    .el-step__description.is-success,
    .el-step__title.is-process,
    .el-step__head.is-process,
    .el-step__description.is-process {
      color: #e2211c;
      border-color: #e2211c;
    }
  }

  table {
    width: 96%;
    border: 1px solid #dcdfe6;
    text-align: left;
    border-collapse: collapse;
  }
  td {
    border: 1px solid #dcdfe6;
    padding: 5px;
    line-height: 2em;
  }
}
</style>